// FAZ-54 — "Okundu" kaydının 5 saniye kuralı.
//
// Kullanıcı kararı: bir başvuru, DETAY SAYFASINDA 5 saniyeden fazla kalınırsa
// okundu sayılır. Gerekçesi ("daha mantıklı ve adaletli olur"): listede yanlışlıkla
// tıklamak ya da detayı açıp hemen geri dönmek "okudu" demek değildir.
//
// Kurallar:
//   • Sekme arka plandayken sayaç DURUR — orada geçen süre okuma sayılmaz.
//   • Ziyaret başına EN FAZLA bir istek gider.
//   • Veri hazır değilken (yükleniyor/hata) sayaç hiç başlamaz — boş ekranda
//     beklemek okuma değildir.
//   • İstek başarısız olursa sessizce yutulur; yan işlev kullanıcıyı rahatsız etmez.

import { useEffect, useRef } from "react";

import { recordApplicationRead } from "../services/belediyeApi";

export const DWELL_MS = 5000;

export default function useReadReceipt(applicationId, { ready = true } = {}) {
  const gonderildiRef = useRef(false);

  // Başvuru değişince "bu ziyarette gönderildi" bayrağı sıfırlanır.
  useEffect(() => {
    gonderildiRef.current = false;
  }, [applicationId]);

  useEffect(() => {
    if (!applicationId || !ready) return undefined;
    if (gonderildiRef.current) return undefined;

    let kalanMs = DWELL_MS;
    let baslangic = null;
    let timer = null;

    const gonder = () => {
      if (gonderildiRef.current) return;
      gonderildiRef.current = true;
      Promise.resolve(recordApplicationRead(applicationId)).catch(() => {});
    };

    const durdur = () => {
      if (timer === null) return;
      clearTimeout(timer);
      timer = null;
      if (baslangic !== null) {
        kalanMs -= Date.now() - baslangic;
        baslangic = null;
      }
    };

    const basla = () => {
      if (timer !== null || gonderildiRef.current) return;
      baslangic = Date.now();
      timer = setTimeout(gonder, Math.max(0, kalanMs));
    };

    const gorunurlukDegisti = () => {
      if (document.visibilityState === "visible") basla();
      else durdur();
    };

    if (document.visibilityState === "visible") basla();
    document.addEventListener("visibilitychange", gorunurlukDegisti);

    return () => {
      durdur();
      document.removeEventListener("visibilitychange", gorunurlukDegisti);
    };
  }, [applicationId, ready]);
}
